export class Validator {
    @addError('EXPRESS_APPLICATION_REQUIRED_FIELD')
    static isNotEmpty(value) {
        return typeof value === 'string' ? !!value.trim() : !!value;
    }

    @addError('EXPRESS_APPLICATION_REQUIRED_FIELD')
    static isNeed(need, value) {
        return typeof value === 'string' ? !!value.trim() : !!value;
    }

    @addError('EXPRESS_APPLICATION_MORE_2_CHAR_FIELD')
    static isMoreTwo(value) {
        value = value.trim();

        return value.length > 2;
    }

    @addError('EXPRESS_APPLICATION_EMAIL_ADDRESS_ERROR')
    static email(value) {
        value = value.trim();
        if (!value) {
            return true;
        }
        // eslint-disable-next-line no-useless-escape
        const regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        return regExp.test(value);
    }

    @addError('EXPRESS_APPLICATION_OKPO_OR_INN_ERROR')
    static inn(value) {
        value = value.trim();
        const regExp = /^[0-9]+(\.[0-9]{1,2})?$/,
            length = value.length > 9 && value.length <= 10;
        return length && regExp.test(value);
    }

    @addError('EXPRESS_APPLICATION_ANY_NUMBER')
    static isNumber(value) {
        const regExp = /^[0-9]+(\.[0-9]{1,2})?$/;
        value = value.trim();

        return regExp.test(value);
    }

    @addError('EXPRESS_APPLICATION_SOLID_NUMBER')
    static isInteger(value) {
        const regExp = /^[0-9]+?$/;
        value = value.trim();

        return regExp.test(value);
    }

    @addError('EXPRESS_APPLICATION_SUM')
    static aExpressSum(value) {
        value = value.replace(' ', '');
        return +value > 0;
    }

    @addError('EXPRESS_APPLICATION_OVERSIZE')
    static fileSize(value) {
        if (value.size) {
            return value.size <= 2000000;
        }
        return true;
    }

    @addError('EXPRESS_APPLICATION_PHONE_NUMBER_ERROR')
    static phone(value) {
        value = value.trim();
        const regExp = /\+38 \(0[0-9]{2}\) [\d]{3} [\d]{2} [\d]{2}$/g;
        return regExp.test(value);
    }

    @addError('EXPRESS_APPLICATION_MORE_2_CHAR_FIELD')
    static password(value) {
        value = value.trim();
        return value.length >= 3 && value.length <= 20;
    }

    static validate(obj) {
        obj.isValid = true;
        obj.errors = [];
        for (const item in obj.validates) {
            if (typeof obj.validates[item] === 'function' && !obj.validates[item](obj.value)) {
                obj.isValid = false;
                obj.errors.push(obj.validates[item].displayError);
                return false;
            }
        }

        return true;
    }
}

export function addError(error) {
    return (someClass, name, fn) => {
        fn.value.displayError = error;
    };
}

//
// "EXPRESS_APPLICATION_EMAIL_ADDRESS_ERROR": "Неверный почтовый адрес",
//     "EXPRESS_APPLICATION_OKPO_OR_INN_ERROR": "Неверные данные",
//     "EXPRESS_APPLICATION_SUM_ERROR": "Неверный формат данных",
//     "EXPRESS_APPLICATION_PHONE_NUMBER_ERROR": "Неверный номер телефона",
//     "EXPRESS_APPLICATION_REQUIRED_FIELD": "Обязательное поле",
//     "EXPRESS_APPLICATION_SOLID_NUMBER": "Значением поля должно быть целое число",
//     "EXPRESS_APPLICATION_ANY_NUMBER": "Значением поля должно быть число",
//     "EXPRESS_APPLICATION_OVERSIZE": "Размер файла не должен привышать 2 Мб",
